import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from "redux-thunk";

import auth from './reducers/auth';
import user from './reducers/user';
import ui from './reducers/ui';
import uiConfirmDialog from './reducers/uiConfirmDialog';
import university from './reducers/university';
import me from './reducers/me';
import categories from './reducers/categories';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducer = combineReducers({auth, user, ui, uiConfirmDialog, university, me, categories});

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store;